/**
 * @generated SignedSource<<8033a66c7cb069bbc75b93eef19be99d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type chinaFutureTechBriefingsPlusArchiveQuery$data = {
  readonly plusArchiveChinaFutureTechBriefings: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entityId: string;
        readonly " $fragmentSpreads": FragmentRefs<"hooksPlusArticleLinkHandlerArticle" | "plusPrimaryContentItemContent">;
      };
    }>;
  };
  readonly " $fragmentType": "chinaFutureTechBriefingsPlusArchiveQuery";
};
export type chinaFutureTechBriefingsPlusArchiveQuery$key = {
  readonly " $data"?: chinaFutureTechBriefingsPlusArchiveQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"chinaFutureTechBriefingsPlusArchiveQuery">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SectionSegmentV2",
    "kind": "LinkedField",
    "name": "sectionsV2",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "value",
        "plural": true,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "Section",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "VideoSection",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "chinaFutureTechBriefingsTypeUuid"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "chinaFutureTechBriefingsPlusArchiveQuery",
  "selections": [
    {
      "alias": "plusArchiveChinaFutureTechBriefings",
      "args": [
        {
          "fields": [
            {
              "items": [
                {
                  "kind": "Variable",
                  "name": "articleTypeIds.0",
                  "variableName": "chinaFutureTechBriefingsTypeUuid"
                }
              ],
              "kind": "ListValue",
              "name": "articleTypeIds"
            }
          ],
          "kind": "ObjectValue",
          "name": "articleFilterInput"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 2
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": {
            "direction": "DESC",
            "field": "PUBLISHED_DATE"
          }
        }
      ],
      "concreteType": "ContentConnection",
      "kind": "LinkedField",
      "name": "contents",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "plusPrimaryContentItemContent"
                },
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "hooksPlusArticleLinkHandlerArticle",
                  "selections": [
                    {
                      "kind": "InlineDataFragmentSpread",
                      "name": "helpersCheckCanShowInPlusPlatformContent",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "__typename",
                          "storageKey": null
                        },
                        {
                          "kind": "InlineDataFragmentSpread",
                          "name": "helpersCheckArticleIsInSectionsArticle",
                          "selections": (v2/*: any*/),
                          "args": null,
                          "argumentDefinitions": []
                        },
                        {
                          "kind": "InlineDataFragmentSpread",
                          "name": "helpersCheckIsPlusArticle",
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "PaywallType",
                                  "kind": "LinkedField",
                                  "name": "paywallTypes",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "entityUuid",
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "type": "Article",
                              "abstractKey": null
                            }
                          ],
                          "args": null,
                          "argumentDefinitions": []
                        },
                        {
                          "kind": "InlineDataFragmentSpread",
                          "name": "helpersCheckIsStyleArticle",
                          "selections": (v2/*: any*/),
                          "args": null,
                          "argumentDefinitions": []
                        },
                        {
                          "kind": "InlineDataFragmentSpread",
                          "name": "helpersGetArticleTypeArticle",
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "ArticleTypeSegment",
                                  "kind": "LinkedField",
                                  "name": "types",
                                  "plural": true,
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "ArticleType",
                                      "kind": "LinkedField",
                                      "name": "value",
                                      "plural": true,
                                      "selections": (v1/*: any*/),
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "type": "Article",
                              "abstractKey": null
                            }
                          ],
                          "args": null,
                          "argumentDefinitions": []
                        },
                        {
                          "kind": "InlineDataFragmentSpread",
                          "name": "helpersUseContentSponsorContent",
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Topic",
                              "kind": "LinkedField",
                              "name": "topics",
                              "plural": true,
                              "selections": [
                                (v0/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Sponsor",
                                  "kind": "LinkedField",
                                  "name": "sponsor",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "args": null,
                                      "kind": "FragmentSpread",
                                      "name": "sponsorTagSponsor"
                                    },
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "name",
                                      "storageKey": null
                                    },
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "type",
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "sponsorType",
                                  "storageKey": null
                                }
                              ],
                              "type": "Article",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineDataFragmentSpread",
                              "name": "helpersCheckIsMainTopicContent",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Topic",
                                  "kind": "LinkedField",
                                  "name": "topics",
                                  "plural": true,
                                  "selections": (v1/*: any*/),
                                  "storageKey": null
                                }
                              ],
                              "args": null,
                              "argumentDefinitions": []
                            }
                          ],
                          "args": null,
                          "argumentDefinitions": []
                        }
                      ],
                      "args": null,
                      "argumentDefinitions": []
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "urlAlias",
                      "storageKey": null
                    }
                  ],
                  "args": null,
                  "argumentDefinitions": []
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "9a0b3ab71c0ec5d9bde025320564c421";

export default node;
